import JSEncrypt from 'jsencrypt/bin/jsencrypt'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = `MIIBCgKCAQEAs0Y1wcnhv0eCXt + wvLU6NPmgRRTYtR09hvdz3CnSNgAkuZzzmRKk
Fr2sikE3nTUPRPVbchQjKY9j3J5qe3uSqIY1tBKUXKiOFa8lJ / 7SChVlS3I0WkUd
OivWVR7EhaLucV9OtI1CCnMnxrxx5O677sOqe23ljRIe7Om4BtsZNkJIZWqsJX69
rlMFf / rbC8UST3t7X7AOfjQfdplxfdk3X1EPTDL8CYM7PCH9eGTSWBrpvHbdHKDF
RVj3HyFkLUdxkX4TMOzw4ncTzkbmNS1viV08O6yr661O0sRQYan / q4IasFPFy04R
JSnVmN / MpcQ9mZD33jxX8m0FF8gt5Y + dbQIDAQAB`;

const privateKey = 'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' +
  'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' +
  'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' +
  '/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' +
  'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' +
  'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' +
  '4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' +
  'tTbklZkD2A=='

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey)
  return encryptor.decrypt(txt)
}

